// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"bj","arrowBtnBox":"bj","arrow-btn-wrap-box":"bk","arrowBtnWrapBox":"bk","arrow-btn-text":"bl","arrowBtnText":"bl","arrow-btn-arrow":"bm","arrowBtnArrow":"bm"};